/*
*****************************************************************************
**                                                                         **
** Copyright (c) 2012-2024, Tyker Technology BV                            **
** All rights reserved.                                                    **
**                                                                         **
** This software is the confidential and proprietary information of        **
** Tyker Technology BV. Unauthorized copying or disclosure of this file,   **
** via any medium is strictly prohibited. This file is only available to   **
** authorized individuals with the permission of the copyright holders.    **
** If you encounter this file and do not have permission, please contact   ** 
** the copyright holders and delete this file.                             **
**                                                                         **
***************************************************************************** 
*/

export const __RP_STATE_IDLE = 1;
export const __RP_STATE_TASK_ON = 2;
export const __RP_STATE_SPRAY_ON = 3;
export const __RP_STATE_UNKNOWN = 4;
export const __RP_STATE_SURVEY = 5;
export const __RP_STATE_POINT = 6;

/*var localGPSStateId = {};
localGPSStateId[GPS_STATE_NOTCONNECTED] = 'notConnected';
localGPSStateId[GPS_STATE_CONNECTED] = 'connected';
localGPSStateId[GPS_STATE_RECEIVING] = 'receiving';
localGPSStateId[GPS_STATE_CONNECTING] = 'connecting';
localGPSStateId[GPS_STATE_RETRYCONNECTING] = 'retryConnection';
export const GPSStateId = Object.freeze(localGPSStateId);*/

export const __OP_SPRAYSTEERINGLINES = 'SpraySteeringlines';
export const __OP_MILLINGDEPTHCONTROL = 'MillingDepthControl';
export const __OP_SURVEY = 'Survey';
export const __OP_SPRAYPOINTS = 'SprayPoints';
export const __OP_MOTIONPLAN = 'Motionplan';
export const __OP_VECTOR = 'Vector';

export const __RESOURCETYPE_DXF = '__RESOURCETYPE_DXF';
export const __RESOURCETYPE_CSV = '__RESOURCETYPE_CSV';
export const __RESOURCETYPE_MOTIONPLAN = '__RESOURCETYPE_MOTIONPLAN';

export const __IDENTIFIERTYPE_ENVIRONMENT = '__IDENTIFIERTYPE_ENVIRONMENT';
export const __IDENTIFIERTYPE_STEERINGLINE = '__IDENTIFIERTYPE_STEERINGLINE';
export const __IDENTIFIERTYPE_MILLINGMODEL = '__IDENTIFIERTYPE_MILLINGMODEL';
export const __IDENTIFIERTYPE_DESIGNMODEL = '__IDENTIFIERTYPE_DESIGNMODEL';
export const __IDENTIFIERTYPE_CURRENTMODEL = '__IDENTIFIERTYPE_CURRENTMODEL';
export const __IDENTIFIERTYPE_HEIGHTMAP = '__IDENTIFIERTYPE_HEIGHTMAP';
export const __IDENTIFIERTYPE_ORIGINAL = '__IDENTIFIERTYPE_ORIGINAL';
export const __IDENTIFIERTYPE_EDITING = '__IDENTIFIERTYPE_EDITING';
export const __IDENTIFIERTYPE_FILECOLLECTION = '__IDENTIFIERTYPE_FILECOLLECTION';
export const __IDENTIFIERTYPE_EDITED = '__IDENTIFIERTYPE_EDITED';
export const __IDENTIFIERTYPE_SPRAYPOINTS = '__IDENTIFIERTYPE_SPRAYPOINTS';
export const __IDENTIFIERTYPE_MOTIONPLAN = '__IDENTIFIERTYPE_MOTIONPLAN';
export const __IDENTIFIERTYPE_PROPOSEDUPDATE = '__IDENTIFIERTYPE_PROPOSEDUPDATE';


export const __TASKSTATUSTYPE_NEW = '__TASKSTATUSTYPE_NEW';
export const __TASKSTATUSTYPE_PLANNED = '__TASKSTATUSTYPE_PLANNED';
export const __TASKSTATUSTYPE_IN_PROGRESS = '__TASKSTATUSTYPE_IN_PROGRESS';
export const __TASKSTATUSTYPE_DONE = '__TASKSTATUSTYPE_DONE';
export const __TASKSTATUSTYPE_REMOVED = '__TASKSTATUSTYPE_REMOVED';


export const __SUBSCRIPTION_RPR = 'RPR1';
export const __SUBSCRIPTION_RBP = 'RP1';

export const __SUBSCRIPTION_RP_CIV_BASIC = 'RP_CIV_BASIC1';
export const __SUBSCRIPTION_RP_CIV_STANDARD = 'RP_CIV_STANDARD1';
export const __SUBSCRIPTION_RP_CIV_ADVANCED = 'RP_CIV_ADVANCED1';
export const __SUBSCRIPTION_RP_CIV_ADMIN = 'RP_CIV_ADMIN1';

export const __SUBSCRIPTION_VCT = 'VCT1';

export const __SUPPORTED_ACADVERS = ['AC1015', 'AC1018', 'AC1021', 'AC1024', 'AC1027', 'AC1032'];

export const __FUNCTIONGROUP_ADMIN = 1;
export const __FUNCTIONGROUP_TRACKING = 2;
export const __FUNCTIONGROUP_ASBUILTDRAWING = 3;
export const __FUNCTIONGROUP_DXFCONNECTDISCONNECTLINES = 4;
export const __FUNCTIONGROUP_DXFREMOVELAYERS = 5;
export const __FUNCTIONGROUP_DXFREMOVEDOUBLEPOINTS = 6;
export const __FUNCTIONGROUP_MOTIONPLANBASIC = 7;
export const __FUNCTIONGROUP_MOTIONPLANAUTOMATIC = 8;
export const __FUNCTIONGROUP_MOTIONPLANSPRAYPOINTS = 9;
export const __FUNCTIONGROUP_ASBUILTREPORT = 10;
